export const LINEUP_SLOT_IDS = [
  "C",
  "1B",
  "2B",
  "3B",
  "SS",
  "LF",
  "CF",
  "RF",
  "P",
  "DH",
];

export const LINEUP_SLOTS = [
  { id: "C", label: "Catcher", short: "C" },
  { id: "1B", label: "First Base", short: "1B" },
  { id: "2B", label: "Second Base", short: "2B" },
  { id: "3B", label: "Third Base", short: "3B" },
  { id: "SS", label: "Shortstop", short: "SS" },
  { id: "LF", label: "Left Field", short: "LF" },
  { id: "CF", label: "Center Field", short: "CF" },
  { id: "RF", label: "Right Field", short: "RF" },
  { id: "P", label: "Pitcher", short: "P" },
  { id: "DH", label: "Designated Hitter", short: "DH" },
];

export const MAX_FAVORITES = 8;

export const BATTING_ORDER_SLOT_IDS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const BATTING_HOLES = [
  { id: "1", short: "1", label: "Leadoff", pickLabel: "leadoff" },
  { id: "2", short: "2", label: "2-hole", pickLabel: "2-hole" },
  { id: "3", short: "3", label: "3-hole", pickLabel: "3-hole" },
  { id: "4", short: "4", label: "Cleanup", pickLabel: "cleanup" },
  { id: "5", short: "5", label: "5-hole", pickLabel: "5-hole" },
  { id: "6", short: "6", label: "6-hole", pickLabel: "6-hole" },
  { id: "7", short: "7", label: "7-hole", pickLabel: "7-hole" },
  { id: "8", short: "8", label: "8-hole", pickLabel: "8-hole" },
  { id: "9", short: "9", label: "9-hole", pickLabel: "9-hole" },
];

export const BATTING_LEADERS_SLOT = "H";
